import { Component, OnInit } from "@angular/core";
import { User } from "./_models/user-models/user";
import { AppSessionState } from "./_services/common/app.service";
import { AppMainComponent } from "./app.main.component";

@Component({
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
  model: any[];
  public client: User = new User();
  lblLatestRouter: string = "Latest Router";
  constructor(
    public appMain: AppMainComponent,
    private _appState: AppSessionState
  ) {}

  ngOnInit() {
    this.client = JSON.parse(this._appState.getSessionStorage());
    if (this.client.LatestRouterVersionNo) {
      this.lblLatestRouter =
        "Latest Router " + this.client.LatestRouterVersionNo;
    }
    // ['SP','Customer','Hospital','Viewer']
    this.model = [
      {
        label: "Dashboard",
        icon: "pi pi-fw pi-chart-line",
        routerLink: ["/dashboard/chart"],
        roleType: ["All"],
      },
      {
        label: "Worklist",
        icon: "pi pi-fw pi-book",
        routerLink: ["/study/worklist"],
        roleType: ["All"],
      },
      {
        label: "Pet Owner",
        icon: "pi pi-users",
        routerLink: ["/study/pet-owner"],
        roleType: ["All"],
      },
      {
        label: "Radiologist Contract",
        icon: "pi pi-clone",
        routerLink: ["/study/radiologist-contract"],
        roleType: ["SP", "HospitalImaging", "CustomerD"],
      },
      {
        label: "Hospital Contract",
        icon: "pi pi-clone",
        routerLink: ["/study/hospital-contract"],
        roleType: ["SP", "Hospital"],
      },
      {
        label: "Invoice",
        icon: "pi pi-clone",
        routerLink: ["/study/invoice-list"],
        roleType: ["SP"],
      },
      {
        label: "Appointment",
        icon: "pi pi-fw pi-cog",
        routerLink: ["/blocks"],
        items: [
          {
            label: "Appointment/Schedule",
            icon: "pi pi-calendar",
            routerLink: ["/study/appointment"],
            roleType: ["SP", "Hospital"],
          },
          {
            label: "Appointment Setup",
            icon: "pi pi-fw pi-cog",
            routerLink: ["/study/appointment-setup"],
            roleType: ["HospitalImaging", "SP"],
          },
        ],
        roleType: ["SP", "Hospital"],
      },
      {
        label: "Study Tracking",
        icon: "pi pi-map-marker",
        routerLink: ["/study/study-tracking-by-accession"],
        roleType: ["All"],
      },
      {
        label: "Report Template",
        icon: "pi pi-id-card",
        routerLink: ["/study/report-template"],
        roleType: ["CustomerD"],
      },
      {
        label: "Exam Info.",
        icon: "pi pi-align-justify",
        routerLink: ["/study/exam-info"],
        roleType: ["CustomerA", "Hospital"],
      },
      {
        label: "User list",
        icon: "pi pi-fw pi-users",
        routerLink: ["/study/userlist"],
        roleType: ["SP", "CustomerA"],
      },
      {
        label: "Org Setup",
        icon: "pi pi-fw pi-unlock",
        routerLink: ["/study/org-info"],
        roleType: ["SP", "Hospital"],
      },
      {
        label: "Unlock Worklist",
        icon: "pi pi-fw pi-unlock",
        routerLink: ["/study/unlock-worklist"],
        roleType: ["All"],
      },
      {
        label: "Int. Monitoring Center",
        icon: "pi pi-fw pi-circle",
        routerLink: ["/study/integration-monitoring-center"],
        roleType: ["SP", "Hospital"],
      },
      {
        label: "Earning Type Setting",
        icon: "pi pi-fw pi-unlock",
        routerLink: ["/study/earningtype-setting"],
        roleType: ["SP"],
      },
      {
        label: "Job Type Setup",
        icon: "pi pi-fw pi-cog",
        routerLink: ["/blocks"],
        items: [
          {
            label: "Job Type",
            icon: "pi pi-fw pi-lock",
            routerLink: ["/study/jobtype-list"],
            roleType: ["SP"],
          },
          {
            label: "Job Type Level",
            icon: "pi pi-fw pi-lock",
            routerLink: ["/study/jobtypelevel-list"],
            roleType: ["SP"],
          },
          {
            label: "Job Type Permission",
            icon: "pi pi-fw pi-lock",
            routerLink: ["/study/jobtypepermission-list"],
            roleType: ["SP"],
          },
        ],
        roleType: ["SP"],
      },
      {
        label: "Reports",
        icon: "pi pi-file-pdf",
        routerLink: ["/blocks"],
        items: [
          {
            label: "Report Setting",
            icon: "pi pi-eye",
            routerLink: ["/study/report-setting"],
            roleType: ["SP1"],
          },
          {
            label: "Report Job Type Setting",
            icon: "pi pi-eye",
            routerLink: ["/study/report-jobtypesetting"],
            roleType: ["SP"],
          },
          {
            label: "Report Viewer",
            icon: "pi pi-eye",
            routerLink: ["/study/report-viewer"],
            roleType: ["All"],
          },
        ],
        roleType: ["All"],
      },
      {
        label: this.lblLatestRouter,
        icon: "pi pi-fw pi-download",
        routerLink: ["/study/router-upload"],
        roleType: ["SP", "Hospital"],
      },
    ];
  }

  menuHide(menu: any) {
    let res = true; // menu hide
    // console.log(menu)
    menu.roleType.forEach((element) => {
      if (element == this.client.OrgType) {
        res = false;
      }
      if (element == "HospitalImaging") {
        if (this.client.IsImaging) {
          res = false;
        }
      }

      if (element == "All") {
        res = false;
      }
      if (element == this.client.OrgType + this.client.JobType) {
        // jobtype Radiologists hole hide

        res = false;
      }
    });
    return res;
  }

  onMenuClick() {
    this.appMain.menuClick = true;
  }
}
